import React from "react";
import { Box, Button, Card, Typography } from "@mui/material";

export default function SprintEmptyState({ onOpenConnections }) {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "8px",
        borderColor: "#dde6ef",
        p: { xs: 2.4, md: 3 },
        boxShadow: "0 20px 42px rgba(15, 23, 42, 0.08)",
      }}
    >
      <Typography sx={{ fontSize: { xs: "1.6rem", md: "2rem" }, fontWeight: 850, letterSpacing: 0, color: "#102033" }}>
        Start Accountability
      </Typography>
      <Typography sx={{ mt: 1, maxWidth: 520, color: "#62758d", lineHeight: 1.65 }}>
        Accountability is a Daily Report agreement with one TrustBud. Every day ends with a report: Done, Reset, or No report.
      </Typography>
      <Box sx={{ mt: 2.25 }}>
        <Button
          variant="contained"
          onClick={onOpenConnections}
          sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 800, px: 2.1 }}
        >
          Open Connections
        </Button>
      </Box>
    </Card>
  );
}
